﻿import config from "../config"
const baseUrl = config.base_url + "sys_mock_data/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    get: {
        url:  baseUrl + "get",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    save:{
        url:  baseUrl + "save",
        type: "post",
    },
    groupList:{
        url:  baseUrl + "group",
        type: "get",
    }
}

